<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card
      :style="{
        backgroundColor: 'rgba(255, 255, 255)',
        width: '100%',
        height: '100%'
      }"
      class="d-flex flex-column justify-center align-center"
    >
      <div class="pa-5 text-center d-flex flex-column" style="gap: 10px;">
        <img
          v-if="brandSrc"
          class="brand"
          :src="brandSrc"
          alt="logo tricot"
        >
        <h2 v-if="title" class="font-weight-regular">
          {{ title }}
        </h2>
        <h3 v-if="description" class="font-weight-regular" style="color: #767070;">
          {{ description }}
        </h3>
      </div>
      <Advertisement v-if="isActiveAds" style="width: 100%;" />
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  components: {
    Advertisement: () => import(/* webpackPrefetch: true */ '@/views/advertisements/Index.vue')
  },
	props: {
    content: {
      type: Object,
      default: null
    }
	},
  computed: {
    ...mapState({
      dialog: state => state.totem.waitingDialog.show
    }),
    isActiveAds () {
      return this.content?.active_advertisement ? true : false
    },
    title () {
      return this.content?.title ?? null
    },
    description () {
      return this.content?.description ?? null
    },
    brandSrc () {
      return this.content?.brand_src ?? null
    }
  }
})
export default class WaitingDialog extends Vue {}
</script>

<style scoped>
.brand {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 auto;
}
</style>
